import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=58956b9e&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=58956b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58956b9e",
  null
  
)

export default component.exports